import React from "react";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Input } from "@/components/ui/input";
import { ReferrerPicker } from "@/components/booking/ReferrerPicker";

export const CLIENT_SOURCES = [
  "Meta ads (Facebook / Instagram)", "Instagram (organic)", "Facebook (organic)", "TikTok", "Google search", "Google Ads", "Google Maps / reviews",
  "Website", "Friend / word of mouth", "Existing client", "Walk-in / passing by", "Print / flyer / signage", "Event / expo / market",
  "Email / SMS campaign", "Influencer / creator", "Gift voucher", "Other",
];
export const isReferral = (s = "") => /friend|word of mouth|refer/i.test(s);

// One picker for "How did they hear about us?" — any marketing avenue, with the referrer link when it's word of mouth.
export const SourcePicker = ({ value = "", onChange, referredBy, onReferredBy, clients = [], excludeId, testId = "client-source" }) => {
  const known = CLIENT_SOURCES.includes(value);
  const custom = value && !known;
  return (
    <div className="space-y-2">
      <Select value={custom ? "Other" : value || undefined} onValueChange={(v) => onChange(v === "Other" ? (custom ? value : "Other") : v)}>
        <SelectTrigger className="h-11 rounded-lg" data-testid={testId}><SelectValue placeholder="How did they hear about you?" /></SelectTrigger>
        <SelectContent className="max-h-72">{CLIENT_SOURCES.map((o) => <SelectItem key={o} value={o}>{o}</SelectItem>)}</SelectContent>
      </Select>
      {(value === "Other" || custom) && <Input placeholder="Where exactly? (e.g. local magazine, gym partnership)" value={custom ? value : ""} onChange={(e) => onChange(e.target.value || "Other")} className="h-10 rounded-lg" data-testid={`${testId}-other`} />}
      {isReferral(value) && onReferredBy && <ReferrerPicker clients={clients} value={referredBy || ""} onChange={onReferredBy} excludeId={excludeId} />}
    </div>
  );
};
